module.exports = __webpack_public_path__ + "img/org-complete.b418abd1.svg";